/** FPS and frame times from recent frame deltas (ms). */
export interface FrameStats {
  fps: number;
  avgMs: number;
  maxMs: number;
}

export function frameStats(deltas: readonly number[]): FrameStats {
  const d = deltas.filter((x) => x > 0 && Number.isFinite(x));
  if (d.length === 0) return { fps: 0, avgMs: 0, maxMs: 0 };
  const sum = d.reduce((a, b) => a + b, 0);
  const avgMs = sum / d.length;
  return { fps: 1000 / avgMs, avgMs, maxMs: Math.max(...d) };
}

export const formatFrameStats = (s: FrameStats) =>
  `${Math.round(s.fps)} fps · ${s.avgMs.toFixed(1)}ms avg · ${s.maxMs.toFixed(0)}ms max`;
